import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from "react-router-dom";

import { Header } from "../../components/Header";
import { LessonItem } from "../../components/LessonItem";
import { useCheckAuth } from "../../hooks/useCheckAuth";

import { LESSONS } from "../../content/lessons";

import './Topic.styles.scss';

export const Topic: React.FC<any> = ({ user }) => {
  // const [isAuth, setAuth] = useState<boolean>();
  // const [userId, setUserId] = useState<string>('');
  // const { topicName } = useParams();
  // const location = useLocation();
  // const navigate = useNavigate();
  useCheckAuth();
  // const { lessons, imagePath, imageAlt } = location.state?.topic as StateTopicType;
  const lessons = LESSONS;


  const lessonsInProgress = lessons.sort((a, b) => a.order - b.order);

  console.log('lessons', lessons)
  return (
    <>
      <Header goBack={true} logOut={true} />
      <main className="LandingContainer Topic">
        <div className="ImageContainer">
          <img src="/images/topics/nature_2.webp" alt="nature" className="Image"/>
        </div>
        <div className="LessonsContainer">
          { LESSONS.map(lesson =>
            <LessonItem
              key={lesson.id}
              id={lesson.id}
              isUnlocked={lesson.active}
              // @ts-ignore
              type={lesson.lesson_type}
              activityType={lesson.activity_type}
              status={lesson.status}
              activities={lesson.activities}
              // @ts-ignore
              lessons={lessonsInProgress}
            />
          )}
        </div>
      </main>
    </>
  );
};
